module.exports = __webpack_public_path__ + "img/defender.212a6dc4.svg";